export interface Projeto {
  id: string;
  nome: string;
  tipo: string;
  cliente: string;
  municipio: string;
  uf: string;
  status: string;
  responsavel: string;
  equipe: string[];
  metodologia: string;
  dataInicio: string;
  dataPrevisao: string;
  dataConclusao?: string;
  progresso: number;
  totalArvores: number;
  vistoriasRealizadas: number;
  vistoriasPendentes: number;
  arvoresRevisao: number;
  riscoCritico: number;
  especiesIdentificadas: number;
  fotosAnexadas: number;
  co2eEstimado: number;
  areaInventariada: number;
  areaAbrangencia: string;
  ultimaAtualizacao: string;
  alertas: string[];
  prioridade: "normal" | "alta" | "critica";
}

export const tiposProjeto = [
  "Implantação do CTA Municipal",
  "Inventário Arbóreo Urbano",
  "Inventário de Praça",
  "Inventário de Parque",
  "Inventário de Loteamento",
  "Inventário de Condomínio",
  "Inventário de Árvores de Risco",
  "Inventário de UC",
  "Monitoramento Ambiental",
  "Compensação Ambiental",
  "Projeto de Carbono",
];

export const statusProjeto = [
  "planejado",
  "em campo",
  "em revisão",
  "concluído",
  "homologado",
  "arquivado",
  "bloqueado",
];

export const statusConfig: Record<string, { badge: string; label: string }> = {
  planejado: { badge: "bg-secondary-100 text-secondary-700", label: "Planejado" },
  "em campo": { badge: "bg-primary-100 text-primary-700", label: "Em Campo" },
  "em revisão": { badge: "bg-warning-100 text-warning-700", label: "Em Revisão" },
  concluido: { badge: "bg-accent-100 text-accent-700", label: "Concluído" },
  homologado: { badge: "bg-primary-50 text-primary-600", label: "Homologado" },
  arquivado: { badge: "bg-background-100 text-foreground-500", label: "Arquivado" },
  bloqueado: { badge: "bg-danger-100 text-danger-700", label: "Bloqueado" },
};

export const ufs = ["GO", "SP", "PR", "SC", "MG", "RJ", "RS"];

export const responsaveis = [
  "Carlos Mendes",
  "Ana Oliveira",
  "Rafael Torres",
  "Juliana Costa",
  "Marcos Vinicius",
  "Pedro Alves",
  "Fernanda Lima",
  "Gabriel Santos",
];

export const projetos: Projeto[] = [
  {
    id: "PRJ-2026-005",
    nome: "Implantação do CTA — Goiânia Centro",
    tipo: "Implantação do CTA Municipal",
    cliente: "Prefeitura de Goiânia - AMMA",
    municipio: "Goiânia",
    uf: "GO",
    status: "em campo",
    responsavel: "Carlos Mendes",
    equipe: ["Carlos Mendes", "Ana Oliveira", "Pedro Alves", "Fernanda Lima"],
    metodologia: "Metodologia CTA-FloraIQ v2.1 - Levantamento fotogramétrico + vistoria técnica",
    dataInicio: "2026-04-10",
    dataPrevisao: "2026-12-15",
    progresso: 45,
    totalArvores: 3850,
    vistoriasRealizadas: 1723,
    vistoriasPendentes: 2127,
    arvoresRevisao: 89,
    riscoCritico: 12,
    especiesIdentificadas: 47,
    fotosAnexadas: 4820,
    co2eEstimado: 1285,
    areaInventariada: 320,
    areaAbrangencia: "Setor Central, Setor Marista, Jardim Goiás",
    ultimaAtualizacao: "2026-06-30",
    alertas: ["3 vistorias atrasadas há mais de 15 dias", "Falta base cartográfica atualizada do setor Marista"],
    prioridade: "alta",
  },
  {
    id: "PRJ-2026-006",
    nome: "Inventário Arbóreo — Praça Universitária",
    tipo: "Inventário de Praça",
    cliente: "Universidade Federal de Goiás - UFG",
    municipio: "Goiânia",
    uf: "GO",
    status: "concluido",
    responsavel: "Rafael Torres",
    equipe: ["Rafael Torres", "Gabriel Santos"],
    metodologia: "CTA Compacto - Praças e logradouros de pequena extensão",
    dataInicio: "2026-01-15",
    dataPrevisao: "2026-03-30",
    dataConclusao: "2026-03-25",
    progresso: 100,
    totalArvores: 234,
    vistoriasRealizadas: 234,
    vistoriasPendentes: 0,
    arvoresRevisao: 0,
    riscoCritico: 3,
    especiesIdentificadas: 28,
    fotosAnexadas: 680,
    co2eEstimado: 68,
    areaInventariada: 8.5,
    areaAbrangencia: "Praça Universitária e entorno imediato",
    ultimaAtualizacao: "2026-03-25",
    alertas: [],
    prioridade: "normal",
  },
  {
    id: "PRJ-2026-007",
    nome: "Loteamento Verde Vale",
    tipo: "Inventário de Loteamento",
    cliente: "Construtora Vale Verde Ltda",
    municipio: "Goiânia",
    uf: "GO",
    status: "em campo",
    responsavel: "Ana Oliveira",
    equipe: ["Ana Oliveira", "Fernanda Lima"],
    metodologia: "CTA Empresarial - Compensação ambiental + inventário pré-obra",
    dataInicio: "2026-05-01",
    dataPrevisao: "2026-08-30",
    progresso: 62,
    totalArvores: 1420,
    vistoriasRealizadas: 890,
    vistoriasPendentes: 530,
    arvoresRevisao: 34,
    riscoCritico: 8,
    especiesIdentificadas: 35,
    fotosAnexadas: 2100,
    co2eEstimado: 425,
    areaInventariada: 145,
    areaAbrangencia: "Loteamento Verde Vale - Área total do empreendimento",
    ultimaAtualizacao: "2026-06-28",
    alertas: ["8 árvores com risco crítico próximas a área de loteamento", "Relatório parcial pendente de revisão técnica"],
    prioridade: "alta",
  },
  {
    id: "PRJ-2026-008",
    nome: "Parque Municipal Ambiental Norte",
    tipo: "Inventário de Parque",
    cliente: "Prefeitura de Goiânia - Secretaria de Meio Ambiente",
    municipio: "Goiânia",
    uf: "GO",
    status: "em revisão",
    responsavel: "Juliana Costa",
    equipe: ["Juliana Costa", "Marcos Vinicius", "Gabriel Santos"],
    metodologia: "CTA Integral - Parques e áreas protegidas com levantamento florístico completo",
    dataInicio: "2026-02-20",
    dataPrevisao: "2026-07-15",
    progresso: 88,
    totalArvores: 5670,
    vistoriasRealizadas: 4980,
    vistoriasPendentes: 690,
    arvoresRevisao: 156,
    riscoCritico: 22,
    especiesIdentificadas: 89,
    fotosAnexadas: 8200,
    co2eEstimado: 2140,
    areaInventariada: 280,
    areaAbrangencia: "Parque Municipal Ambiental Norte - Área total protegida",
    ultimaAtualizacao: "2026-06-29",
    alertas: ["22 árvores críticas identificadas - necessário plano de manejo emergencial", "Dados de GPS inconsistentes na ala leste do parque"],
    prioridade: "critica",
  },
  {
    id: "PRJ-2026-009",
    nome: "Monitoramento de Árvores Críticas — Setor Bueno",
    tipo: "Inventário de Árvores de Risco",
    cliente: "Condomínio Bueno Vista - Síndico",
    municipio: "Goiânia",
    uf: "GO",
    status: "em campo",
    responsavel: "Pedro Alves",
    equipe: ["Pedro Alves"],
    metodologia: "CTA Risco - Monitoramento trimestral de árvores classificadas como alto risco",
    dataInicio: "2026-03-10",
    dataPrevisao: "2026-09-10",
    progresso: 55,
    totalArvores: 89,
    vistoriasRealizadas: 48,
    vistoriasPendentes: 41,
    arvoresRevisao: 0,
    riscoCritico: 15,
    especiesIdentificadas: 12,
    fotosAnexadas: 320,
    co2eEstimado: 12,
    areaInventariada: 3.2,
    areaAbrangencia: "Condomínio Bueno Vista - Áreas comuns e calçadas",
    ultimaAtualizacao: "2026-06-27",
    alertas: ["15 árvores em risco crítico - relatório de segurança urgente", "Vistoria trimestral atrasada em 12 dias"],
    prioridade: "critica",
  },
  {
    id: "PRJ-2026-010",
    nome: "Inventário de UC — Parque Natural Municipal",
    tipo: "Inventário de UC",
    cliente: "ICMBio - Superintendência em Goiás",
    municipio: "Goiânia",
    uf: "GO",
    status: "planejado",
    responsavel: "Fernanda Lima",
    equipe: ["Fernanda Lima", "Rafael Torres"],
    metodologia: "CTA UC - Inventário arbóreo para Unidade de Conservação com SIG integrado",
    dataInicio: "2026-07-15",
    dataPrevisao: "2026-12-20",
    progresso: 5,
    totalArvores: 0,
    vistoriasRealizadas: 0,
    vistoriasPendentes: 0,
    arvoresRevisao: 0,
    riscoCritico: 0,
    especiesIdentificadas: 0,
    fotosAnexadas: 0,
    co2eEstimado: 0,
    areaInventariada: 0,
    areaAbrangencia: "Parque Natural Municipal - Área total da UC",
    ultimaAtualizacao: "2026-06-15",
    alertas: ["Aguardando autorização do órgão gestor para início de campo", "Base cartográfica da UC em processo de homologação"],
    prioridade: "normal",
  },
  {
    id: "PRJ-2026-011",
    nome: "Compensação Ambiental — Corredor Verde Sul",
    tipo: "Compensação Ambiental",
    cliente: "Incorporadora Sul Verde S.A.",
    municipio: "Goiânia",
    uf: "GO",
    status: "concluido",
    responsavel: "Marcos Vinicius",
    equipe: ["Marcos Vinicius", "Gabriel Santos"],
    metodologia: "CTA Compensação - Inventário pré-obra + monitoramento pós-plantio",
    dataInicio: "2025-09-01",
    dataPrevisao: "2026-05-30",
    dataConclusao: "2026-05-28",
    progresso: 100,
    totalArvores: 2150,
    vistoriasRealizadas: 2150,
    vistoriasPendentes: 0,
    arvoresRevisao: 0,
    riscoCritico: 0,
    especiesIdentificadas: 42,
    fotosAnexadas: 5600,
    co2eEstimado: 640,
    areaInventariada: 185,
    areaAbrangencia: "Corredor Verde Sul - Área de compensação ambiental",
    ultimaAtualizacao: "2026-05-28",
    alertas: ["Monitoramento pós-plantio deve continuar por mais 24 meses"],
    prioridade: "normal",
  },
  {
    id: "PRJ-2026-012",
    nome: "Projeto Carbono Urbano — Áreas Verdes Municipais",
    tipo: "Projeto de Carbono",
    cliente: "Secretaria de Meio Ambiente - Prefeitura de Goiânia",
    municipio: "Goiânia",
    uf: "GO",
    status: "em revisão",
    responsavel: "Gabriel Santos",
    equipe: ["Gabriel Santos", "Fernanda Lima"],
    metodologia: "CTA Carbono - Inventário para estimativa de sequestro de carbono com protocolo VCS",
    dataInicio: "2026-01-05",
    dataPrevisao: "2026-06-30",
    progresso: 92,
    totalArvores: 8920,
    vistoriasRealizadas: 8210,
    vistoriasPendentes: 710,
    arvoresRevisao: 234,
    riscoCritico: 18,
    especiesIdentificadas: 67,
    fotosAnexadas: 14200,
    co2eEstimado: 3560,
    areaInventariada: 520,
    areaAbrangencia: "Áreas verdes municipais - 12 praças, 4 parques, 3 corredores",
    ultimaAtualizacao: "2026-06-29",
    alertas: ["Calibragem do modelo alométrico pendente para espécies nativas do Cerrado", "Relatório de carbono aguardando validação de terceira parte"],
    prioridade: "alta",
  },
];

export const documentosProjeto = [
  { id: "DOC-001", nome: "Termo de Abertura do Projeto", tipo: "termo", status: "aprovado", data: "2026-04-10", tamanho: "2.4 MB" },
  { id: "DOC-002", nome: "Metodologia do Inventário - CTA FloraIQ v2.1", tipo: "metodologia", status: "aprovado", data: "2026-04-12", tamanho: "8.7 MB" },
  { id: "DOC-003", nome: "Base Cartográfica - Goiânia Centro (Shapefile)", tipo: "cartografia", status: "pendente", data: "2026-04-15", tamanho: "45.2 MB" },
  { id: "DOC-004", nome: "Relatório Parcial - Inventário Abr/2026", tipo: "relatorio", status: "revisao", data: "2026-05-30", tamanho: "12.1 MB" },
  { id: "DOC-005", nome: "Fotos de Campo - Lote 01 ao 15", tipo: "fotos", status: "aprovado", data: "2026-06-15", tamanho: "1.2 GB" },
  { id: "DOC-006", nome: "Autorização Ambiental - AMMA 2026/0458", tipo: "autorizacao", status: "aprovado", data: "2026-04-08", tamanho: "1.8 MB" },
];

export const atividadesProjeto = [
  { id: "ACT-001", descricao: "Levantamento fotogramétrico iniciado no Setor Central", data: "2026-06-28", usuario: "Carlos Mendes", tipo: "campo" },
  { id: "ACT-002", descricao: "345 árvores cadastradas no dia", data: "2026-06-27", usuario: "Ana Oliveira", tipo: "cadastro" },
  { id: "ACT-003", descricao: "12 vistorias de risco realizadas", data: "2026-06-26", usuario: "Pedro Alves", tipo: "vistoria" },
  { id: "ACT-004", descricao: "Base cartográfica do Setor Marista enviada para revisão", data: "2026-06-25", usuario: "Fernanda Lima", tipo: "documento" },
  { id: "ACT-005", descricao: "Relatório parcial de abril aprovado pelo gestor", data: "2026-06-24", usuario: "Carlos Mendes", tipo: "relatorio" },
  { id: "ACT-006", descricao: "Equipe ampliada com mais 2 técnicos de campo", data: "2026-06-20", usuario: "Carlos Mendes", tipo: "equipe" },
];

export const resumoProjetos = {
  ativos: 18,
  emCampo: 7,
  emRevisao: 4,
  concluidos: 23,
  totalArvores: 12486,
  areaInventariada: 842,
};

export interface MembroEquipe {
  nome: string;
  funcao: string;
  email: string;
  telefone: string;
  cadastros: number;
  vistorias: number;
  status: string;
}

export interface RelatorioProjeto {
  id: string;
  nome: string;
  descricao: string;
  status: string;
  ultimaGeracao: string;
  tipo: string;
}

export interface QualidadeProjeto {
  coordenadaValida: number;
  comFoto: number;
  especieIdentificada: number;
  vistoriaValidada: number;
  responsavelTecnico: number;
  recomendacaoPreenchida: number;
}

export interface VistoriaProjeto {
  id: string;
  codigoCta: string;
  data: string;
  tipo: string;
  tecnico: string;
  estado: string;
  risco: string;
  recomendacao: string;
  status: string;
}

export interface AlertaProjeto {
  tipo: string;
  mensagem: string;
  severidade: string;
  quantidade: number;
}

export const equipeDetalhada: MembroEquipe[] = [
  { nome: "Carlos Mendes", funcao: "Responsável Técnico", email: "carlos.mendes@floraiq.eco", telefone: "(62) 99991-2345", cadastros: 1240, vistorias: 520, status: "ativo" },
  { nome: "Ana Oliveira", funcao: "Técnica de Campo", email: "ana.oliveira@floraiq.eco", telefone: "(62) 99992-3456", cadastros: 980, vistorias: 410, status: "ativo" },
  { nome: "Pedro Alves", funcao: "Técnico de Campo", email: "pedro.alves@floraiq.eco", telefone: "(62) 99993-4567", cadastros: 850, vistorias: 380, status: "ativo" },
  { nome: "Fernanda Lima", funcao: "Analista GIS", email: "fernanda.lima@floraiq.eco", telefone: "(62) 99994-5678", cadastros: 520, vistorias: 220, status: "ativo" },
  { nome: "Juliana Costa", funcao: "Fiscal", email: "juliana.costa@floraiq.eco", telefone: "(62) 99995-6789", cadastros: 180, vistorias: 140, status: "ativo" },
  { nome: "Gabriel Santos", funcao: "Consultor Externo", email: "gabriel.santos@consultoria.eco", telefone: "(62) 99996-7890", cadastros: 80, vistorias: 72, status: "inativo" },
];

export const relatoriosProjeto: RelatorioProjeto[] = [
  { id: "REL-001", nome: "Relatório Técnico de Implantação do CTA", descricao: "Documento técnico completo com todos os resultados de campo, mapas, estatísticas e recomendações finais do projeto.", status: "disponivel", ultimaGeracao: "2026-06-30", tipo: "tecnico" },
  { id: "REL-002", nome: "Relatório de Inventário Arbóreo Urbano", descricao: "Inventário consolidado com lista completa de árvores, coordenadas, dados dendrométricos e fotos.", status: "disponivel", ultimaGeracao: "2026-06-28", tipo: "inventario" },
  { id: "REL-003", nome: "Relatório Fotográfico", descricao: "Compilação de todas as fotos georreferenciadas organizadas por lote, setor e espécie.", status: "disponivel", ultimaGeracao: "2026-06-25", tipo: "fotografico" },
  { id: "REL-004", nome: "Relatório de Árvores de Risco", descricao: "Lista detalhada das árvores classificadas como risco alto ou crítico, com justificativa técnica e recomendações.", status: "gerando", ultimaGeracao: "2026-06-20", tipo: "risco" },
  { id: "REL-005", nome: "Relatório por Espécie", descricao: "Distribuição e análise por espécie, grupo ecológico, origem e estado fitossanitário.", status: "disponivel", ultimaGeracao: "2026-06-22", tipo: "especie" },
  { id: "REL-006", nome: "Relatório por Bairro", descricao: "Indicadores por bairro: densidade arbórea, cobertura de copa, estado geral e recomendações por setor.", status: "pendente", ultimaGeracao: "—", tipo: "bairro" },
  { id: "REL-007", nome: "Relatório de Manejo Recomendado", descricao: "Consolidado de recomendações de manejo com priorização e estimativa de custos.", status: "pendente", ultimaGeracao: "—", tipo: "manejo" },
  { id: "REL-008", nome: "Relatório Executivo", descricao: "Resumo executivo para gestores com indicadores-chave, gráficos e recomendações estratégicas.", status: "disponivel", ultimaGeracao: "2026-06-29", tipo: "executivo" },
];

export const qualidadeProjeto: QualidadeProjeto = {
  coordenadaValida: 96.8,
  comFoto: 92.4,
  especieIdentificada: 98.5,
  vistoriaValidada: 89.2,
  responsavelTecnico: 100,
  recomendacaoPreenchida: 94.7,
};

export const vistoriasProjeto: VistoriaProjeto[] = [
  { id: "VST-001", codigoCta: "CTA-GO-5208707-000001", data: "2026-06-25", tipo: "Rotina", tecnico: "Carlos Mendes", estado: "bom", risco: "baixo", recomendacao: "Monitorar", status: "concluída" },
  { id: "VST-002", codigoCta: "CTA-GO-5208707-000002", data: "2026-06-18", tipo: "Rotina", tecnico: "Ana Oliveira", estado: "regular", risco: "medio", recomendacao: "Poda de limpeza", status: "concluída" },
  { id: "VST-003", codigoCta: "CTA-GO-5208707-000005", data: "2026-06-28", tipo: "Rotina", tecnico: "Carlos Mendes", estado: "bom", risco: "baixo", recomendacao: "Monitorar", status: "concluída" },
  { id: "VST-004", codigoCta: "CTA-GO-5208707-000007", data: "2026-06-22", tipo: "Rotina", tecnico: "Pedro Alves", estado: "bom", risco: "baixo", recomendacao: "Sem intervenção", status: "concluída" },
  { id: "VST-005", codigoCta: "CTA-GO-5208707-000099", data: "2026-06-15", tipo: "Emergencial", tecnico: "Carlos Mendes", estado: "ruim", risco: "alto", recomendacao: "Poda emergencial", status: "em revisão" },
  { id: "VST-006", codigoCta: "CTA-GO-5208707-000034", data: "2026-06-10", tipo: "Rotina", tecnico: "Ana Oliveira", estado: "regular", risco: "medio", recomendacao: "Tratamento fitossanitário", status: "concluída" },
  { id: "VST-007", codigoCta: "CTA-GO-5208707-000056", data: "2026-06-05", tipo: "Revisão", tecnico: "Fernanda Lima", estado: "bom", risco: "baixo", recomendacao: "Sem intervenção", status: "pendente" },
  { id: "VST-008", codigoCta: "CTA-GO-5208707-000012", data: "2026-06-01", tipo: "Rotina", tecnico: "Pedro Alves", estado: "regular", risco: "alto", recomendacao: "Poda corretiva", status: "concluída" },
  { id: "VST-009", codigoCta: "CTA-GO-5208707-000078", data: "2026-05-28", tipo: "Rotina", tecnico: "Carlos Mendes", estado: "bom", risco: "baixo", recomendacao: "Monitorar", status: "concluída" },
  { id: "VST-010", codigoCta: "CTA-GO-5208707-000091", data: "2026-05-20", tipo: "Emergencial", tecnico: "Ana Oliveira", estado: "critico", risco: "critico", recomendacao: "Supressão", status: "vencida" },
];

export const alertasProjeto: AlertaProjeto[] = [
  { tipo: "risco", mensagem: "Árvores com risco crítico sem vistoria nos últimos 30 dias", severidade: "critica", quantidade: 4 },
  { tipo: "foto", mensagem: "Registros sem foto anexada", severidade: "media", quantidade: 142 },
  { tipo: "especie", mensagem: "Registros sem espécie identificada", severidade: "media", quantidade: 28 },
  { tipo: "vistoria", mensagem: "Vistorias pendentes de validação técnica", severidade: "alta", quantidade: 196 },
  { tipo: "relatorio", mensagem: "Relatório final do projeto ainda não gerado", severidade: "media", quantidade: 1 },
];

export const atividadesDetalhadasProjeto = [
  { id: "ACT-001", descricao: "Levantamento fotogramétrico iniciado no Setor Central — Lote 01 ao 05", data: "2026-06-28", usuario: "Carlos Mendes", tipo: "campo" },
  { id: "ACT-002", descricao: "345 árvores cadastradas no Setor Marista", data: "2026-06-27", usuario: "Ana Oliveira", tipo: "cadastro" },
  { id: "ACT-003", descricao: "12 vistorias de risco realizadas — 2 emergenciais", data: "2026-06-26", usuario: "Pedro Alves", tipo: "vistoria" },
  { id: "ACT-004", descricao: "Base cartográfica do Setor Marista enviada para revisão GIS", data: "2026-06-25", usuario: "Fernanda Lima", tipo: "documento" },
  { id: "ACT-005", descricao: "Relatório parcial de abril aprovado pelo gestor do projeto", data: "2026-06-24", usuario: "Carlos Mendes", tipo: "relatorio" },
  { id: "ACT-006", descricao: "Equipe ampliada com 2 novos técnicos de campo", data: "2026-06-20", usuario: "Carlos Mendes", tipo: "equipe" },
  { id: "ACT-007", descricao: "GPS Topcon recalibrado para novo ciclo de campo", data: "2026-06-18", usuario: "Fernanda Lima", tipo: "equipe" },
  { id: "ACT-008", descricao: "Laudo fitossanitário do Flamboyant (Rua das Acácias) anexado", data: "2026-06-15", usuario: "Ana Oliveira", tipo: "documento" },
];